export class ResourceIdFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceIdFilters.attributeTypeMap;
    }
    constructor() {
    }
}
